import { AppTreeSide, UniDateRangePicker } from 'components'
import validatorMixin from '@/mixins/validator-mixin.js' // 引入mixin文件
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree, loadStreamNodeTreeItems} from '@/utils/tree'
import {getTodayBeginAndEndDate} from '@/utils/date'

export default {
  name: 'CaptureRecord',
  data() {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      // 树节点已加载的区域id数组
      treeNodeLoadedRegionIds: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: false,
      dates: [], // 查询起始和结束日期
      tableQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        captureBeginDateTime: 0,
        captureEndDateTime: 0,
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      tableSelectedRows: [],
      // 加锁/解锁参数
      lockParams: {
        captureRecordIds: [],
        lockDuration: 0,
        locked: 0
      },
      // 弹窗
      drawerOpen: false
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    validatorMixin,
    ssoLoginMixin,
    idNameMixin,
    convertorMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted() {
    // 设置查询起始日期和截止日期
    this.dates = getTodayBeginAndEndDate()

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询视频节点列表
    getStreamNodeList(regionId) {
      // 检测该区域下视频节点是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.loading = true
      this.$http(this.$api.streamNodeList, {
        regionId: regionId,
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            if (res.data.length) {
              this.treeData = loadStreamNodeTreeItems(res.data, this.treeData)
              if (this.$refs.tree.currentNode && this.treeExpandedKeys.indexOf(this.$refs.tree.currentNode.node.key) === -1) {
                this.treeExpandedKeys.push(this.$refs.tree.currentNode.node.key) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询录像记录列表
    getCaptureRecordList() {
      this.loading = true
      this.tableQueryParams.descendantRegionRequired = this.tableQueryParams.nodeId === 0 ? 1 : 0 // 指定节点id后不需要查询子区域
      this.tableQueryParams.captureBeginDateTime = this.dates[0].getTime() / 1000
      this.tableQueryParams.captureEndDateTime = this.dates[1].getTime() / 1000
      this.$http(this.$api.captureRecordList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (obj.type === 'region' && this.tableQueryParams.regionId !== obj.id) {
        this.tableQueryParams.regionId = obj.id
        this.tableQueryParams.nodeId = 0
        this.tableQueryParams.pageNum = 1
        this.getStreamNodeList(obj.id)
        this.getCaptureRecordList()
      } else if (obj.type === 'streamNode' && this.tableQueryParams.nodeId !== obj.id) {
        this.tableQueryParams.regionId = obj.regionId
        this.tableQueryParams.nodeId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getCaptureRecordList()
      }
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getCaptureRecordList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.nodeId = 0
      this.tableQueryParams.descendantRegionRequired = 1
      this.tableQueryParams.captureBeginDateTime = 0
      this.tableQueryParams.captureEndDateTime = 0
      this.dates = getTodayBeginAndEndDate()
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getCaptureRecordList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getCaptureRecordList()
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedRows = selection
      this.tableSelectedIds = selection.map(item => item.id)
    },
    // 锁定
    handleLock(row, value) {
      this.$messagebox.confirm(value === 1 ? '您确定锁定选中的文件吗?' : '您确定解锁选中的文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row && row.id) {
          this.lockParams.captureRecordIds = []
          this.lockParams.captureRecordIds.push(row.id)
          this.lockParams.locked = value
        } else {
          this.lockParams.captureRecordIds = this.tableSelectedIds
          this.lockParams.locked = value
        }
        this.$http(this.$api.lockCaptureRecord, this.lockParams).then(
          res => {
            if (res.code === 200) {
              this.tableQueryParams.pageNum = 1
              this.getCaptureRecordList()
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 下载文件
    handleView(row) {
      if (row && row.id) {
        if (!row.url) {
          this.$message({type: 'warning', message: '无效文件url!'})
          return
        }
        this.tableSelectedRows = []
        this.$refs.table.clearSelection()
        this.tableSelectedRows.push(row)
        this.drawerOpen = true
      } else if (this.tableSelectedRows.length > 0) {
        this.drawerOpen = true
      }
    },
    // 取消提交记录
    handleModalCancel() {
      this.drawerOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/captureRecord/CaptureRecord.js